// Szukajka globalna w pasku górnym (WYGLAD.md #1) - po stronie APP, bez osobnej trasy: urządzenia z bramy (nazwa,
// numer), instrukcje (lista z serwera, raz na sesję) i przepisy (istniejące szukanie `q` listy przepisów w obu
// dziedzinach - wędzenie i trunki, każde konto). Klik prowadzi do pulpitu sztuki, instrukcji albo listy przepisów
// dziedziny z wpisanym szukaniem.
import { useEffect, useState } from "react";
import { Link } from "react-router";
import type { DziedzinaPrzepisu, ManualCardOut } from "../gen/kontrakt";
import { t } from "../i18n/t";
import { instrukcje } from "../api/instrukcje";
import { BEZ_FILTRA, przepisy } from "../api/przepisy";
import { useSklad } from "../brama/uzyj";
import { nazwaSztuki } from "../linie/opisy";
import { IkonaInstrukcje, IkonaPrzepisy, IkonaUrzadzenia, type KomponentIkony } from "../uklad/ikony";

const NA_GRUPE = 5;
const ZWLOKA_MS = 300;
const DZIEDZINY: DziedzinaPrzepisu[] = ["wedzarnia", "trunki"];

interface Wynik { klucz: string; nazwa: string; do: string; ikona: KomponentIkony }

let listaInstrukcji: ManualCardOut[] | null = null;

const pasuje = (tekst: string, q: string) => tekst.toLowerCase().includes(q);

export function WynikiSzukania({ q, onWybierz }: { q: string; onWybierz: () => void }) {
  const sklad = useSklad();
  const fraza = q.trim().toLowerCase();
  const [instr, ustawInstr] = useState<ManualCardOut[]>(listaInstrukcji ?? []);
  const [prz, ustawPrz] = useState<Wynik[]>([]);
  useEffect(() => {
    if (!fraza || listaInstrukcji) return;
    instrukcje().then((o) => { listaInstrukcji = o.instrukcje; ustawInstr(o.instrukcje); }, () => undefined);
  }, [fraza]);
  useEffect(() => {
    if (fraza.length < 2) return;
    let zywy = true;
    const z = setTimeout(() => {
      Promise.all(DZIEDZINY.map((dziedzina) => przepisy({ ...BEZ_FILTRA, dziedzina, q: fraza }).then((o) =>
        Object.values(o.sekcje).flatMap((s) => s.przepisy).map((p) => ({ klucz: "p" + p.id, nazwa: p.nazwa,
          do: `/przepisy?dziedzina=${dziedzina}&szukaj=${encodeURIComponent(p.nazwa)}`, ikona: IkonaPrzepisy })))))
        .then((w) => { if (zywy) ustawPrz(w.flat().slice(0, NA_GRUPE)); }, () => undefined);
    }, ZWLOKA_MS);
    return () => { zywy = false; clearTimeout(z); };
  }, [fraza]);
  if (!fraza) return null;
  const urzadzenia: Wynik[] = sklad.filter((d) => pasuje(nazwaSztuki(d), fraza) || d.sn.includes(fraza)).slice(0, NA_GRUPE)
    .map((d) => ({ klucz: "u" + d.sn, nazwa: nazwaSztuki(d), do: "/urzadzenia/" + encodeURIComponent(d.sn), ikona: IkonaUrzadzenia }));
  const instrukcjeW: Wynik[] = instr.filter((m) => pasuje(t(m.tytul), fraza)).slice(0, NA_GRUPE)
    .map((m) => ({ klucz: "i" + m.id, nazwa: t(m.tytul), do: "/instrukcje/" + encodeURIComponent(m.id), ikona: IkonaInstrukcje }));
  const grupy = [
    { tytul: t("Urządzenia"), wyniki: urzadzenia },
    { tytul: t("Przepisy"), wyniki: fraza.length >= 2 ? prz : [] },
    { tytul: t("Instrukcje"), wyniki: instrukcjeW },
  ].filter((g) => g.wyniki.length > 0);
  return (
    <div className="iot-szukaj__wyniki iot-menu" role="region" aria-label={t("Wyniki szukania")} aria-live="polite">
      {grupy.length === 0 && <p className="iot-menu__naglowek">{t("Nic nie znaleziono.")}</p>}
      {grupy.map((g) => (
        <div key={g.tytul}>
          <p className="iot-nadtytul iot-szukaj__grupa">{g.tytul}</p>
          {g.wyniki.map((w) => (
            <Link key={w.klucz} to={w.do} className="iot-menu__pozycja" onClick={onWybierz}><w.ikona />{w.nazwa}</Link>
          ))}
        </div>
      ))}
    </div>
  );
}
